export const PROGRAM_INFORMATION_CLOSED_SIGNAL = 'programInformationClosed';
